import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-aa9d9eac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "watermark-preview-wrap" }
const _hoisted_2 = { class: "preview-head" }
const _hoisted_3 = { class: "preview-image-wrap" }
const _hoisted_4 = { class: "preview-zoom-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewImage = _resolveComponent("PreviewImage")!
  const _component_WatermarkZoom = _resolveComponent("WatermarkZoom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('screenWatermark.previewTitle')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_PreviewImage, {
            class: "preview-zoom",
            wmdata: _ctx.wmdata
          }, null, 8, ["wmdata"])
        ]),
        _createElementVNode("div", {
          class: "zoom-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.watermarkZoomVisible = true))
        })
      ])
    ]),
    _createVNode(_component_WatermarkZoom, {
      modelValue: _ctx.watermarkZoomVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.watermarkZoomVisible) = $event)),
      wmdata: _ctx.wmdata
    }, null, 8, ["modelValue", "wmdata"])
  ], 64))
}